/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import { ChevronsUpDown, XIcon } from "lucide-react";

import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/components/ui/command";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";

import { Fragment, useEffect, useMemo, useState } from "react";
import { GenericType } from "@/types";
import { removeByKeyPaths } from "@/pages/retailer/utils/react-hook/utils";
export const IgnoreKeysSelect = ({
  placeholder,
  value,
  onChange,
  defaultValue,
  options,
  bindValue,
  className,
  onBlur,
  noLimit,
}: GenericType) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      if (defaultValue) {
        onChange(defaultValue);
      }
    }, 100);
  }, [defaultValue]);

  const onChangeHandle = (prop: any) => {
    if (Array.isArray(value)) {
      const checkIsExist = value?.find((item: any) => item === prop);
      if (checkIsExist) {
        const updatedList = value?.filter((item: any) => item !== prop);
        onChange(updatedList);
      } else {
        const updatedList = value;
        updatedList.push(prop);
        onChange(updatedList);
      }
    } else {
      onChange([prop]);
    }
  };

  const display_list = useMemo(() => {
    return removeByKeyPaths(options, value || [], { prune: false });
  }, [options, value]);

  console.log({ options });

  return (
    <>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button
            variant="outline"
            role="combobox"
            aria-expanded={open}
            className={cn(
              "w-full justify-between capitalize",
              className,
              noLimit ? "px-2 h-auto gap-2 py-[6.5px] min-h-[40px]" : ""
            )}
          >
            <span className={cn(noLimit ? "flex flex-wrap gap-1" : "truncate")}>
              {value?.[0] ? (
                <Fragment>
                  {value.map((cItem: string) => {
                    return (
                      <span
                        className="pr-2 bg-slate-50 text-slate-600 inline-flex items-center gap-1 border-slate-200 border rounded-md text-xs mr-1 px-2 py-1"
                        key={cItem}
                      >
                        {cItem}
                        <Button
                          className="p-0 h-auto hover:text-red-500"
                          onClick={(e) => {
                            e.stopPropagation();
                            onChangeHandle(cItem);
                          }}
                          variant={"ghost"}
                        >
                          <XIcon />
                        </Button>
                      </span>
                    );
                  })}
                </Fragment>
              ) : (
                <span className="opacity-65">{placeholder}</span>
              )}
            </span>
            <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
          </Button>
        </PopoverTrigger>

        <PopoverContent
          className="w-full p-0  z-[9999]"
          align="start"
          onBlur={onBlur}
        >
          <Command>
            <CommandInput placeholder="Search..." className="h-9" />
            <CommandList>
              <CommandEmpty>No Item found.</CommandEmpty>
              <CommandGroup>
                {display_list?.map((option: GenericType, index: number) => {
                  return (
                    <div
                      key={index}
                      // value={option?.[bindLabel]}
                      onSelect={() => {
                        onChangeHandle(option?.[bindValue]);
                      }}
                      className="border-b"
                    >
                      <NestedList
                        option={option}
                        onChangeHandle={onChangeHandle}
                      />
                      {/* <Check
                      className={cn(
                        "ml-auto",
                        checkIsActive(option?.[bindValue]?.toLowerCase())
                          ? "opacity-100"
                          : "opacity-0"
                      )}
                    /> */}
                    </div>
                  );
                })}
              </CommandGroup>
            </CommandList>
            <div className="hidden grid-cols-2 gap-2 border-t p-2 bg-gray-50">
              <Button
                variant={"outline"}
                disabled={value?.length === options?.length}
                onClick={() => {
                  const allValue = options.map(
                    (item: { [key: string]: any }) => item.value
                  );
                  onChange(allValue);
                }}
                className={cn("p-1 text-xs border-primary text-primary h-auto")}
              >
                Select All
              </Button>
              <Button
                variant={"outline"}
                disabled={value?.length === 0}
                onClick={() => onChange([])}
                className={cn("p-1 text-xs border-red-500 text-red-500 h-auto")}
              >
                Remove All
              </Button>
            </div>
          </Command>
        </PopoverContent>
      </Popover>
    </>
  );
};

const NestedList = ({ option, onChangeHandle }: any) => {
  return (
    <div>
      {option.list?.length === 0 ? null : (
        <>
          <div className="text-black text-sm font-500 pt-1">
            {option?.heading}
          </div>
          {option.list.map((item: any, index: number) => {
            return (
              <Fragment key={`${item.value}-${index}`}>
                {item.list ? (
                  <div className="pl-5">
                    <div className=" text-black text-sm font-500">
                      {item.label}
                    </div>
                    <div>
                      <NestedList
                        option={item}
                        onChangeHandle={onChangeHandle}
                      />
                    </div>
                  </div>
                ) : (
                  <CommandItem
                    className="pl-5 text-slate-600"
                    onSelect={() => {
                      onChangeHandle(item?.value);
                    }}
                  >
                    {item.label}
                  </CommandItem>
                )}
              </Fragment>
            );
          })}
        </>
      )}
    </div>
  );
};
